import React from 'react';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUser } from '../../modules/selectors';
import { setCookie } from '../../helpers/cookies';

export const PrivateRoute = (props: RouteProps) => {
  const { pathname, search } = useLocation();
  const { authenticated } = useSelector(getUser);
  const redirectURL = '/login';
  let query = '';

  if (search && URLSearchParams) {
    query = '?' + new URLSearchParams(search).toString();
  }

  if (!authenticated && redirectURL !== pathname) {
    // @ts-ignore
    setCookie('authenticatedUrlTarget', pathname + query, 1);
  }

  return authenticated ? (
    <Route {...props} />
  ) : (
    <Redirect
      to={{
        pathname: redirectURL,
        state: { from: props.location }
      }}
    />
  );
};
